export default function Header(props){
    return(
<div className="page-header">
        <span style={{color:"black", position:"relative", top:"24px", paddingBottom:"16px"}}>{props.title}</span>
        <br/><br/>
    </div>
    )
}